import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IdashboardItem } from '../../models';
import { IinitialState } from '../../reducers';
import { Button } from 'react-bootstrap';

interface Iprops {
    loading: boolean;
    items: Array<IdashboardItem>;
    partStatusCounts: Array<number>;
    onStartJob: () => void;
    onClear: () => void;
    isMobile: boolean;
}

const formatPartStatusValue = (number: number) =>
    number.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

const DashboardSummary: React.FC<Iprops & WithTranslation> = props => {
    const { t, items, partStatusCounts, loading, onStartJob, onClear, isMobile } = props;

    const hours = React.useMemo(() => {
        return items.reduce((acc, item) => acc + (item?.workOrder?.plannedHours || 0), 0);
    }, [items]);

    if (isMobile) {
        return (
            <div className="dashboard-summary">
                <div className="smart-summary">
                    <div className="mobile-summary">
                        <p className="smart-summary-label">Smart Summary:</p>
                        <p>{items[0]?.facility?.name || ''}</p>
                        <div className="mobile-summary-content">
                            <span>{items.length} Work Orders</span>
                            <span className="vertical-divider"></span>
                            <span>{hours} Hours</span>
                            <span className="vertical-divider"></span>
                            <div className="parts">
                                <div className="green">{formatPartStatusValue(partStatusCounts[0] ?? 0)}</div>
                                <div className="yellow">{formatPartStatusValue(partStatusCounts[1] ?? 0)}</div>
                                <div className="red">{formatPartStatusValue(partStatusCounts[2] ?? 0)}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mobile-buttons">
                    <Button type="button" className="blue" onClick={onStartJob}>
                        {t('common:startJob')}
                    </Button>
                    <Button type="button" disabled={loading} onClick={onClear}>
                        {t('common:clear')}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.59946 2.34311C3.25233 1.99598 2.68951 1.99598 2.34238 2.34311C1.99525 2.69025 1.99525 3.25306 2.34238 3.60019L6.74216 7.99997L2.34238 12.3997C1.99525 12.7469 1.99525 13.3097 2.34238 13.6568C2.68951 14.004 3.25233 14.004 3.59946 13.6568L7.99924 9.25705L12.399 13.6568C12.7461 14.004 13.309 14.004 13.6561 13.6568C14.0032 13.3097 14.0032 12.7469 13.6561 12.3997L9.25631 7.99997L13.6561 3.60019C14.0032 3.25306 14.0032 2.69025 13.6561 2.34311C13.309 1.99598 12.7461 1.99598 12.399 2.34311L7.99923 6.74289L3.59946 2.34311Z"
                                fill="currentColor"
                            />
                        </svg>
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-summary">
            <Button type="button" className="blue" onClick={onStartJob}>
                {t('common:startJob')}
            </Button>
            <div className="divider"></div>
            <div className="mid">
                <span>Smart Summary:</span>
                <span className="ln">{items.length} Work Orders</span>
                <span className="ln">{items[0]?.facility?.name || ''}</span>
                <span className="ln">{hours} Hours</span>
                <div className="parts">
                    <div className="green">{formatPartStatusValue(partStatusCounts[0] ?? 0)}</div>
                    <div className="yellow">{formatPartStatusValue(partStatusCounts[1] ?? 0)}</div>
                    <div className="red">{formatPartStatusValue(partStatusCounts[2] ?? 0)}</div>
                </div>
            </div>
            <div className="divider"></div>
            <Button type="button" disabled={loading} onClick={onClear}>
                {t('common:clear')}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.59946 2.34311C3.25233 1.99598 2.68951 1.99598 2.34238 2.34311C1.99525 2.69025 1.99525 3.25306 2.34238 3.60019L6.74216 7.99997L2.34238 12.3997C1.99525 12.7469 1.99525 13.3097 2.34238 13.6568C2.68951 14.004 3.25233 14.004 3.59946 13.6568L7.99924 9.25705L12.399 13.6568C12.7461 14.004 13.309 14.004 13.6561 13.6568C14.0032 13.3097 14.0032 12.7469 13.6561 12.3997L9.25631 7.99997L13.6561 3.60019C14.0032 3.25306 14.0032 2.69025 13.6561 2.34311C13.309 1.99598 12.7461 1.99598 12.399 2.34311L7.99923 6.74289L3.59946 2.34311Z"
                        fill="currentColor"
                    />
                </svg>
            </Button>
        </div>
    );
};

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    return {};
};

export default withTranslation('dashboard')(connect(mapStateToProps, {})(DashboardSummary));
